import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faCheck } from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../utils/translations';

const LanguageSelector = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { language, changeLanguage } = useLanguage();
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleLanguageChange = (lang) => {
    changeLanguage(lang);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="language-selector" ref={dropdownRef}>
      <button onClick={toggleDropdown} className="language-toggle">
        <FontAwesomeIcon icon={faGlobe} />
        <span className="language-code">{language.toUpperCase()}</span>
        <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}></span>
      </button>
      
      {isOpen && (
        <div className="language-dropdown">
          <button 
            className={`language-option ${language === 'en' ? 'active' : ''}`} 
            onClick={() => handleLanguageChange('en')}
          >
            {translations[language].english}
            {language === 'en' && <FontAwesomeIcon icon={faCheck} className="check-icon" />}
          </button>
          <button 
            className={`language-option ${language === 'ar' ? 'active' : ''}`} 
            onClick={() => handleLanguageChange('ar')}
          >
            {translations[language].arabic}
            {language === 'ar' && <FontAwesomeIcon icon={faCheck} className="check-icon" />}
          </button>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
